
        import * as module0 from './abas_idioma_controller.js';import * as module1 from './cor_controller.js';import * as module2 from './cpf_mask_controller.js';import * as module3 from './sidebar_controller.js';import * as module4 from './telefone_controller.js'
        export default [module0.default,module1.default,module2.default,module3.default,module4.default];
        export const context = {
          'abas_idioma_controller.js': module0.default,'cor_controller.js': module1.default,'cpf_mask_controller.js': module2.default,'sidebar_controller.js': module3.default,'telefone_controller.js': module4.default
        }
      